import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ActionsList from './actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { HistoricalDataService } from 'src/app/services/historical-data.service';
import { EMPTY } from 'rxjs';

@Injectable()
export class HistoricalChartViewEffects {
  constructor(
    private actions$: Actions,
    private service: HistoricalDataService
  ) {}

  getData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ActionsList.RequestAction),
      switchMap((action: any) =>
        this.service
          .getDataGraph(action.accountId, action.from, action.to)
          .pipe(
            map((data: any) => {
              return ActionsList.ResponseAction({ payload: data.data });
            }),
            catchError((err) => {
              return EMPTY;
            })
          )
      )
    )
  );
}
